import React from 'react';
import { HiHome, HiUser, HiLogout } from 'react-icons/hi';
import '../../styles/SideNavBar.css';

const SideNavBar = ({
  activeTab,
  onTabChange,
  onLogout,
  currentUser
}) => {
  const navigationItems = [
    {
      id: 'home',
      label: 'Home',
      icon: HiHome
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: HiUser
    }
    // Future navigation items can be added here:
    // {
    //   id: 'categories',
    //   label: 'Categories',
    //   icon: HiFolder
    // },
    // {
    //   id: 'courses',
    //   label: 'My Courses',
    //   icon: HiBookOpen
    // }
  ];

  return (
    <div className="side-navbar">
      {/* Logo Section */}
      <div className="navbar-logo">
        <img src="/icons/logo.png" alt="logo" />
      </div>

      {/* Navigation Items */}
      <nav className="navbar-nav">
        {navigationItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            >
              <IconComponent className="nav-icon" />
              <span className="nav-label body3">{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* Logout Section */}
      <div className="navbar-logout">
        <button onClick={onLogout} className="logout-btn">
          <HiLogout className="logout-icon" />
          <span className="logout-label body3">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default SideNavBar;
